/* eslint-disable */
import Swiper from 'swiper'

/**
 * Carousel block functionality
 *
 * @author Alexander de Jong
 *
 */

jQuery.noConflict()
;(function ($) {
    $(function () {
        /**
         * Hold reusable elements.
         *
         * @type {Object}
         */
        const cache = {}

        /**
         * Caches elements that are used in this scope.
         *
         * @return void
         */
        function cacheElements() {
            cache.$window = $(window)
            cache.$document = $(document)
            cache.$slider = $('.swiper-container')
        }

        // // Do we meet the requirements?
        function meetsRequirements() {
            return cache.$slider.length
        }

        /**
         * Setup event binding.
         *
         * @return void
         */
        function bindEvents() {
            if (meetsRequirements()) {
                cache.$window.load(function () {
                    carousel()
                })
            }
        }

        /**
         * Swiper section
         */
        function carousel() {
            $('.hero-slider-container').each(function (index, element) {
                const $this = $(this)

                $this.attr('id', 'hero-slider__instance-' + index)

                $this
                    .parent()
                    .find('.hero-slider-pagination')
                    .attr('id', 'hero-slider-js-pagination-' + index)

                // Only active slider if there is more than 1 slide.
                if ($this.find('.hero-slider__slide').length > 1) {
                    new Swiper('#hero-slider__instance-' + index, {
                        on: {
                            afterInit: function (swiper) {
                                initPauseButton(swiper)
                            }
                        },
                        speed: 500,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        autoHeight: false,
                        direction: 'horizontal',
                        pagination: {
                            el: '#hero-slider-js-pagination-' + index,
                            clickable: true,
                        },
                        loop: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                        },
                        watchSlidesVisibility: true,
                    })
                } else {
                    initPauseButton(null);
                }
            })

            $('.team-carousel-container').each(function (index, element) {
                const $this = $(this)

                $this.attr('id', 'team-carousel__instance-' + index)

                $this
                    .parent()
                    .find('.team-carousel-controls-container')
                    .attr('id', 'team-carousel-js-controls-' + index)

                $this
                    .parent()
                    .find('.team-carousel-pagination-container')
                    .attr('id', 'team-carousel-js-pagination-' + index)

                // Only active slider if there is more than 1 slide.
                if ($this.find('.team-carousel__slide').length > 1) {
                    new Swiper('#team-carousel__instance-' + index, {
                        speed: 500,
                        slidesPerView: 3,
                        spaceBetween: 10,
                        autoHeight: false,
                        direction: 'horizontal',
                        pagination: {
                            el: '#team-carousel-js-pagination-' + index,
                            clickable: true,
                        },
                        navigation: {
                            prevEl: '#team-carousel-js-controls-' + index + ' .team-carousel-control--prev',
                            nextEl: '#team-carousel-js-controls-' + index + ' .team-carousel-control--next',
                        },
                        loop: false,
                        initialSlide: 0,
                        autoplay: {
                            delay: 5000,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: false,
                        },
                        watchSlidesVisibility: true,
                        breakpoints: {
                            0: {
                                slidesPerView: 1,
                                spaceBetween: 15
                            },
                            800: {
                                slidesPerView: 2,
                                spaceBetween: 20
                            },
                            1200: {
                                slidesPerView: 3,
                                spaceBetween: 40
                            }
                        }
                    })
                }
            })
        }

        function init() {
            // Cache the reusable elements
            cacheElements()

            // Bind events
            bindEvents()
        }

        function initPauseButton(swiper) {
            let pauseButton = $('.swiper-pause')[0]
            let videos = $('.swiper-container')[0].querySelectorAll('video')

            // If the swiper contains multiple slides, retrieve the elements through the initialized swiper.
            if (swiper) {
                pauseButton = swiper.el.querySelector('.swiper-pause')
                videos = swiper.el.querySelectorAll('video')
                pauseButton.addEventListener('click', () => toggleSlider(pauseButton, swiper))
            }

            if (videos.length === 0 && swiper === null) {
                return;
            }

            pauseButton.addEventListener('click', () => toggleVideos(pauseButton, videos))
            pauseButton.classList.remove('hidden')
        }

        function toggleVideo(video, isRunning) {
            isRunning ? video.pause() : video.play()
        }

        function toggleVideos(pauseButton, videos) {
            videos.forEach(video => toggleVideo(video, !video.paused))
            pauseButton.classList.toggle('paused')
            pauseButton.ariaLabel = pauseButton.classList.contains('paused') ? 'Video hervatten' : 'Video pauzeren';
        }

        function toggleSlider(pauseButton, swiper) {
            swiper.autoplay.running ? swiper.autoplay.stop() : swiper.autoplay.start()
        }

        // Initialize the actions.
        init()
    })
})(jQuery)



// WEBPACK FOOTER //
// ./scripts/custom/carousel.js